export const INIT = 'INIT';
export const INITED = "INITED";

export const init = () => ({
  type: INIT,
})

export const inited = () => ({
  type: INITED,
})


/** WEBPACK FOOTER **
 ** ./src/app/modules/base/actions.js
 **/